import { Injectable } from '@angular/core';
import { plainToClass } from "class-transformer";

import { FormField } from '../models/form-builder/form-field.model';
import { Form } from '../models/form-builder/form.model';
import { FormInstanceElement } from '../models/form-builder/form-instance-element.model';

export interface IFormFieldDataBusListener {
    set id(listenerId: number);
    get id(): number;

    formFieldValueChanged(form: Form, formField: FormField, row: number, col: number, formInstanceElement: FormInstanceElement): void;
}

export abstract class FormFieldDataBusListenerBase {
    // Properties.
    protected listenerId: number;

    // Constructor.
    public constructor() {
    }

    // Method(s).
    public set id(listenerId: number) {
        this.listenerId = listenerId;
    }
    public get id(): number {
        return this.listenerId;
    }
}

@Injectable({
    providedIn: 'root'
})
export class FormFieldDataBusService {
    // Properties.
    private nextListenerId: number = 1;
    private listeners: IFormFieldDataBusListener[] = [];

    // Constructor.
    public constructor() {
    }

    // Listener registration.
    public registerListener(listener: IFormFieldDataBusListener): void {
        listener.id = this.nextListenerId++;
        this.listeners.push(listener);
    }

    public removeListener(listenerId: number): boolean {
        let numListeners: number = this.listeners.length;
        this.listeners = this.listeners.filter(l => l.id != listenerId);
        return (numListeners != this.listeners.length);
    }

    // Form field value changes.
    public formFieldValueChanged(form: Form, formField: FormField, row: number, column: number, formInstanceElement: FormInstanceElement): void {
        for (let index: number = 0; index < this.listeners.length; index++) {
            let listener = this.listeners[index];
            listener.formFieldValueChanged(form, formField, row, column, formInstanceElement);
        }
    }
}
